function genRandomNumber(usedPorts) {
    let num1
    do {
        num1 = Math.floor(Math.random() * (7000 - 4000 + 1)) + 4000
    } while (usedPorts.includes(num1))
    return num1
}

export default genRandomNumber
